import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getDeploymentScope, TEST_PATH_PREFIX } from "utils/deploymentScope";

/** Booking path for signed-in users who land on QR registration (matches production /buchen). */
export const drHoffmannBuchenPath = () => {
  const prefix = getDeploymentScope() === "test" ? TEST_PATH_PREFIX : "";
  return `${prefix}/buchen`;
};

/** Signed-in users skip QR registration and go straight to booking. */
const QrCodeGuestGate = ({ children }) => {
  const token = useSelector((s) => s.token);
  if (token) {
    return <Navigate to={drHoffmannBuchenPath()} replace />;
  }
  return children;
};

export default QrCodeGuestGate;
